import SvgIcon from "../../SvgIcon";
import NumberInput from '../../NumberInput';
import { ReactComponent as IconCopper } from "../../../res/icons/cp.svg";
import { ReactComponent as IconSilver } from "../../../res/icons/sp.svg";
import { ReactComponent as IconElectrum } from "../../../res/icons/ep.svg";
import { ReactComponent as IconGold } from "../../../res/icons/gp.svg";
import { ReactComponent as IconPlatinum } from "../../../res/icons/pp.svg";

export type CurrencyCode = 'cp' | 'sp' | 'ep' | 'gp' | 'pp';

type CurrencyProps = {
    currency: CurrencyCode;
    value: number;
    onChange: (value: number) => void;
    onBlur: () => void;
    className?: string;
    outline?: boolean;
};

const currencyLabels: Record<CurrencyCode, string> = {
    cp: 'CP', sp: 'SP', ep: 'EP', gp: 'GP', pp: 'PP',
};

const currencyNames: Record<CurrencyCode, string> = {
    cp: 'Copper Pieces', sp: 'Silver Pieces', ep: 'Electrum Pieces',
    gp: 'Gold Pieces', pp: 'Platinum Pieces',
};

function Currency({
    currency,
    value,
    onChange,
    onBlur,
    className = '',
    outline = false,
}: CurrencyProps) {
    const label = currencyLabels[currency];

    return (
        <div className={className} data-currency={currency}>
            <label
                className="form-label small mb-1 text-center d-block"
                htmlFor={`currency-${currency}`}
                title={currencyNames[currency]}
            >
                <span
                    style={{
                        color: currency === 'cp' ? '#b87333' :
                            currency === 'sp' ? '#c0c0c0' :
                                currency === 'ep' ? '#e5e4e2' :
                                    currency === 'gp' ? '#ffd700' :
                                        '#e5e4e2',
                        verticalAlign: '.05em',
                        fontSize: '1.2em',
                    }}
                    className="d-inline-block me-1"
                >
                    <SvgIcon
                        Svg={
                            currency === 'cp' ? IconCopper :
                                currency === 'sp' ? IconSilver :
                                    currency === 'ep' ? IconElectrum :
                                        currency === 'gp' ? IconGold :
                                            IconPlatinum
                        }
                        style={
                            outline ? {
                                stroke: '#000',
                                strokeWidth: 0.75,
                                strokeLinejoin: 'round',
                                paintOrder: 'stroke'
                            } : undefined
                        }
                    />
                </span>
                {label}
            </label>

            <NumberInput
                id={`currency-${currency}`}
                min={0}
                step={1}
                value={value}
                className="form-control text-center"
                onValueChange={onChange}
                onBlur={onBlur}
                aria-label={`${currencyNames[currency]} amount`}
            />
        </div>
    );
}

export default Currency;
